import { useEffect, useState } from "react";
import { onGetAllusers } from "../services/users/Usermanagement";
import { useStateGetter } from "./statehooks/UseStateGettersHook";
import { toast } from "react-toastify";
import { error } from "console";
import { useStateSetter } from "./statehooks/UseStateSettersHook";

const useUsersHook = () => {
  const { config } = useStateGetter();
const {setLoading}=useStateSetter()
  const [allusers, setallusers] = useState<[]>([]);

  const getAllusers = async () => {

    setLoading(true)

    try {
      var response = await onGetAllusers(config);
      setallusers(response.data);
      setLoading(false)

    } catch (e: any) {
      console.log(e);
      toast.error(e);
      setLoading(false)

    }
    setLoading(false)

  };

  useEffect(() => {
    getAllusers();
  }, []);

  return { allusers };
};

export { useUsersHook };
